import { render, staticRenderFns } from "./idtw.vue?vue&type=template&id=a1cf6c32&lang=pug&"
import script from "./idtw.vue?vue&type=script&lang=js&"
export * from "./idtw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports